import TabbedWindow from './TabbedWindow';
import Tab from './Tab';

export { Tab };

export default TabbedWindow;
